import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {getLoggedInUser} from '../utils/functions';
import {UserInfo} from '../types/interfaces';


type UiState = 'idle' | 'submitting' | 'success' | 'error';

export const AdminApproveMerchant: React.FC = () => {
    const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
    const [ui, setUi] = useState<UiState>('idle');
    const [msg, setMsg] = useState('');
    const [accountNo, setAccountNo] = useState('');
    const [token, setToken] = useState('');
    const navigate = useNavigate();

    const API_BASE = process.env.REACT_APP_API_SELFCARE_URL as string;

    useEffect(() => {
        const init = async () => {
            const u = await getLoggedInUser();
            setUserInfo(u);
            if (!u) navigate('/error');
        };
        init();
        // If navigation state provided an account number, prefill the form
        const state = (window.history.state && (window.history.state as any).usr) || null;
        // React Router stores state under history.state.usr in some builds; try to read accountNo
        if (state && state.accountNo) {
            setAccountNo(state.accountNo);
        } else {
            // also try location state via window.history.state && window.history.state.accountNo
            try {
                const navState = (window.history.state && (window.history.state as any).accountNo) || null;
                if (navState) setAccountNo(navState);
            } catch {}
        }
    }, [navigate]);

    const fetchToken = async () => {
        setMsg('');
        setUi('submitting');
        try {
            const res = await fetch(`${API_BASE}/admin-ops/auth/token`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username: 'btc-dealer-1000174', password: 'Pa$$w0rd' })
            });
            const raw = await res.text();
            const json = raw ? JSON.parse(raw) : {};
            if (!res.ok || !json.access_token) {
                setUi('error');
                setMsg(json.message || raw || 'Failed to obtain token');
                return null;
            }
            setToken(json.access_token);
            return json.access_token;
        } catch (e: any) {
            setUi('error');
            setMsg(`Token error: ${e.message}`);
            return null;
        }
    };

    const onApprove = async (e: React.FormEvent) => {
        e.preventDefault();
        setUi('submitting');
        setMsg('');
        if (!accountNo) {
            setUi('error');
            setMsg('Account number is required');
            return;
        }
        let bearer = token;
        if (!bearer) {
            const t = await fetchToken();
            if (!t) return; // fetchToken already set state
            bearer = t;
        }

        try {
            const res = await fetch(`${API_BASE}/admin-ops/approve-merchant/${encodeURIComponent(accountNo)}`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${bearer}`
                },
                body: JSON.stringify({})
            });
            const raw = await res.text();
            let json: any = {}; try { json = raw ? JSON.parse(raw) : {}; } catch { json = { message: raw }; }
            if (!res.ok) {
                setUi('error');
                setMsg(json.message || raw || 'Approval failed');
                return;
            }
            setUi('success');
            setMsg(json.status || 'Account Approved');
        } catch (e: any) {
            setUi('error');
            setMsg(`Approve error: ${e.message}`);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 p-4 md:p-8">
            <div className="max-w-xl mx-auto bg-white rounded-lg shadow p-6">
                <h2 className="text-2xl font-bold text-green-800 mb-6">Approve Merchant</h2>
                {ui !== 'idle' && (
                    <div className={`mb-6 p-4 rounded-lg text-sm ${ui === 'success' ? 'bg-green-50 border-l-4 border-green-500 text-green-700' : 'bg-red-50 border-l-4 border-red-500 text-red-700'}`}>{msg}</div>
                )}
                <form onSubmit={onApprove} className="space-y-4">
                    <div>
                        <label className="block text-sm font-medium text-green-700 mb-1">Account Number</label>
                        <input value={accountNo} onChange={e => setAccountNo(e.target.value)} placeholder="BTCELEC1000230" className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-green-500 focus:border-green-500" required />
                    </div>
                    {/* Rebate is set in the backend; not shown on UI */}
                    <div className="flex gap-3 pt-2">
                        <button type="submit" disabled={ui === 'submitting'} className="flex-1 bg-green-600 hover:bg-green-700 text-white font-semibold py-2 rounded-md">{ui === 'submitting' ? 'Approving…' : 'Approve'}</button>
                        <button type="button" onClick={() => navigate('/admin')} className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-2 rounded-md">Back</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AdminApproveMerchant;

